import { render, staticRenderFns } from "./AttackHistory.vue?vue&type=template&id=7645986e"
import script from "./AttackHistory.vue?vue&type=script&lang=js"
export * from "./AttackHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports